import { useContext, useEffect, useState } from "react";
import { models, Report, Embed } from "powerbi-client";
import { PowerBIEmbed } from "powerbi-client-react";
import { taxPortalClientApi } from "../../api-client-nswag/taxportal-client-runtime";
import { PowerBIReport } from "../../api-client-nswag/taxportal-client";
import { getNewAccessToken, timeOutForRefreshToken } from "../../util/Utils";
import "./SitesBreakDown.scss";
import { OidcIdentityContext } from "@rsmus/react-auth";
import { useRecoilValue } from "recoil";
import { CountryCode } from "../../App";

export const SitesBreakdownPBI = (props: any) => {
  const [flag, setFlag] = useState<boolean | null>(null);
  const { user } = useContext(OidcIdentityContext);
  const countryCode = useRecoilValue(CountryCode)
  const [data, setData] = useState<string>();
  const [tokenTimeout, setTokenTimeout] = useState<any>(null);
  const [tokenExpiration, setTokenExpiration] = useState<Date | null>(null);
  const [filters, setFilters] = useState<any[]>([]);
  const [reportConfigDTO, setReportConfig] = useState<models.IReportEmbedConfiguration>({
    type: "report",
    embedUrl: "",
    tokenType: models.TokenType.Embed,
    accessToken: "",
    settings: undefined,
  });

  const reportContainerStyle = {
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    width: "94vw",
    height: "130vh",
    //padding: '110px 0px 0px 0px'
  };

  useEffect(() => {
    if(countryCode === 'US')
      setData(countryCode)
    else
      setData('Global')
    loadReportConfig();
  }, []);

  useEffect(() => {
    const fil = basicfilterSchema(
      "Location Access",
      "Location", //If site id doesn't work check if siteId is a number, it should not be summarizing it
      "In",
      `${data}`
    );
    setFilters([fil]);
  }, [data]);

  const loadReportConfig = async () => {
    await taxPortalClientApi
      .reports_GetSitesBreakdown(PowerBIReport.SITES_BREAKDOWN)
      .then((res) => {
        const settings = {
          type: "report",
          embedUrl: res?.embedUrl,
          accessToken: res?.token,
          settings: {
            filterPaneEnabled: true,
            navContentPaneEnabled: false,
          },
        };

        setReportConfig(settings);
        setFlag(false);
        const expiresIn = new Date(res.expiration as Date);
        expiresIn.setMinutes(expiresIn.getMinutes() - 2);
        setTokenExpiration(expiresIn);
      })
      .catch((err) => {
        if (err.status === 401) {
          setFlag(true);
        }
      });
  };

  const basicfilterSchema = (tableName: string, columnName: string, operator: string, field: unknown | null) => {
    return {
      $schema: "http://powerbi.com/product/schema#basic",
      target: {
        table: tableName,
        column: columnName,
      },
      filterType: models.FilterType.Basic,
      operator: operator,
      values: [field],
      requireSingleSelection: true,
    };
  };

  useEffect(() => {

      if (props.siteReports && filters.length > 0) {
        const onLoadedHandler = () => {
          props.siteReports
            .setFilters(filters)
            .then(() => console.log("Filters applied successfully."))
            .catch(() => console.log("Failed to apply filters."));
        };
        props.siteReports.off("loaded", onLoadedHandler);
        props.siteReports.on("loaded", onLoadedHandler);
        props.siteReports.refresh();
      
    }
  }, [props.siteReports, filters, flag]);

  const refreshAccessToken = async () => {
    if (props.siteReports) {
      const res = await getNewAccessToken(PowerBIReport.CS_PROJECT_TRACKER_LITE);
      if (res && res?.token !== null) {
        const newToken = res.token as string;
        props.siteReports.setAccessToken(newToken);

        const expiresIn = new Date();
        expiresIn.setHours(expiresIn.getHours() + 1);
        setTokenExpiration(expiresIn);

        if (tokenTimeout) {
          clearTimeout(tokenTimeout);
        }

        const currentTime = new Date();
        const refreshTime = expiresIn.getTime() - currentTime.getTime() - 2 * 60 * 1000;
        if (refreshTime > 0) {
          setTokenTimeout(setTimeout(refreshAccessToken, refreshTime));
        }
      }
    } else {
      console.error("Failed to refresh token.");
    }
  };

  useEffect(() => {
    timeOutForRefreshToken(tokenExpiration, setTokenTimeout, refreshAccessToken);
    return () => {
      if (tokenTimeout) {
        clearTimeout(tokenTimeout);
      }
    };
  }, [props.siteReports, tokenExpiration]);

  return (
    <>
      {flag === true ? null : (
        <div style={reportContainerStyle}>
          <PowerBIEmbed
            embedConfig={reportConfigDTO}
            cssClassName="embed-container"
            getEmbeddedComponent={(embedObject: Embed) => {
              props.setSiteReports(embedObject as Report);
            }}
          />
        </div>
      )}
    </>
  );
};
